const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    token: state => state.user.token,
    userInfo: state => state.user.userInfo,
    addRouters: state => state.permission.addRoutes,
    routers: state => state.permission.routes
}
export default getters
